import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { recipesV2AccessControl } from '../access-control/recipesV2Access.configuration'

const RecipesV2ListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RecipesV2ListPage" */
      '../pages/RecipesV2ListPage'
    )
)

// Future pages will be added here (Story 1.2+)
// const RecipesV2CreatePage = lazy(() => import('../pages/RecipesV2CreatePage'))
// const RecipesV2EditPage = lazy(() => import('../pages/RecipesV2EditPage'))

export const recipesV2PartnerScopedRouter = (
  <DomainRoute route="recipes-v2" accessControl={recipesV2AccessControl}>
    <DashSwitch>
      <DomainRoute exact route="recipes-v2" component={RecipesV2ListPage} />
      <DomainRoute exact route="recipes-v2-list" component={RecipesV2ListPage} />
      {/* Future routes will be added here */}
    </DashSwitch>
  </DomainRoute>
)
